import start from '../../../microservices/loaders/sync'

start(() => import('./render'), 'microservice__auth-form__root', {
  lazyStoreManagerLoader: () => import('../../../microservices/lazy-store-manager'),
})
